if (!customElements.get('im-fabric-picker')) {
  customElements.define('im-fabric-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.$ = name => this.querySelector(`[data-im-${name}]`);
      this.dialog = this.querySelector('dialog');
      this.excluded = new Set((this.dataset.excluded || '').split(/\r?\n/).map(x => x.trim().toLocaleLowerCase('lt')).filter(Boolean));
      this.cache = new Map(); this.request = 0; this.limit = 24;
      try {
        const input = JSON.parse(this.$('catalog').textContent);
        if (Array.isArray(input)) {
          const names = [...new Set(input.map(x => x.collection))];
          this.groups = names.map((name,i) => ({id:String(i),title:name}));
          this.groups.forEach(g => this.cache.set(g.id,this.prepare(input.filter(x => x.collection === g.title),g.id)));
        } else { this.groups = input.collections || []; }
      } catch (_) { this.groups = []; }
      for (const group of this.groups) {
        const option = document.createElement('option'); option.value = group.id; option.textContent = group.title;
        this.$('collection').append(option);
      }
      this.catalog = [];
      this.$('open').addEventListener('click', () => this.open());
      this.$('close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.$('open').focus());
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); });
      this.$('collection').addEventListener('change', () => {this.$('search').value='';this.loadCollection();});
      this.$('search').addEventListener('input', () => {this.limit=24;this.render();});
      this.$('more')?.addEventListener('click', () => {this.limit+=24;this.render();});
      this.$('confirm').addEventListener('click', () => {
        if (!this.pending || !this.catalog.includes(this.pending)) return;
        this.selected = this.pending;
        const label = `${this.selected.collection} ${this.selected.code}`;
        this.$('value').value = label;
        this.$('summary').textContent = `${label} · Keisti pasirinkimą`;
        this.$('error').hidden = true; this.dialog.close();
      });
      imSetupMobileFabricFilters(this);
      const form = document.getElementById(this.dataset.form) || this.closest('form');
      form?.addEventListener('submit', e => {
        if (this.dialog.open) {e.preventDefault();e.stopImmediatePropagation();return;}
        if (!this.validateSelection()) {e.preventDefault();e.stopImmediatePropagation();}
      },true);
    }
    prepare(items,groupId,base) {
      const url = path => {
        if (typeof path !== 'string') return '';
        try {const u=new URL(path,base || location.href);return ['https:','http:'].includes(u.protocol)?u.href:'';} catch (_) {return '';}
      };
      return items.filter(x=>x.collection && x.code && x.image && x.enabled!==false && !this.excluded.has(`${x.collection} ${x.code}`.toLocaleLowerCase('lt'))).map(x=>({...x,groupId,code:String(x.code),image:url(x.image),thumb:url(x.thumb||x.image)})).filter(x=>x.image);
    }
    async open() {
      this.pending = this.selected || null;
      if (this.selected) this.$('collection').value=this.selected.groupId;
      this.$('search').value=''; this.preview();
      if (!this.dialog.open) this.dialog.showModal();
      await this.loadCollection();
    }
    async loadCollection() {
      const token=++this.request;
      const group=this.groups.find(g=>g.id===this.$('collection').value);
      this.limit=24;this.catalog=[];this.pending=null;this.preview();this.$('grid').replaceChildren();
      if (this.$('more')) this.$('more').hidden=true;
      if (!group) {this.$('count').textContent='Audinių katalogas nepasiekiamas.';return;}
      this.$('count').textContent='Įkeliamos spalvos…';
      try {
        if (!this.cache.has(group.id)) {
          const response=await fetch(group.url,{credentials:'omit'});
          if (!response.ok) throw new Error('catalog');
          const items=await response.json();if (!Array.isArray(items)) throw new Error('format');
          this.cache.set(group.id,this.prepare(items,group.id,response.url||group.url));
        }
        if (token!==this.request) return;
        this.catalog=this.cache.get(group.id);
        this.pending=this.selected?.groupId===group.id?this.selected:null;
        this.preview();this.render();
      } catch (_) {
        if (token!==this.request) return;
        this.$('count').textContent='Spalvų nepavyko įkelti. Pasirinkite kolekciją dar kartą arba uždarykite ir atverkite langą.';
      }
    }
    validateSelection() {
      const options=this.selected && this.cache.get(this.selected.groupId);
      if (options?.includes(this.selected) && this.$('value').value===`${this.selected.collection} ${this.selected.code}`) return true;
      this.$('error').textContent='Pasirinkite audinį ir spalvą.';this.$('error').hidden=false;this.open();return false;
    }
    render() {
      const q=this.$('search').value.trim().toLocaleLowerCase('lt');
      const matches=this.catalog.filter(x=>`${x.collection} ${x.code}`.toLocaleLowerCase('lt').includes(q));
      const visible=matches.slice(0,this.limit);const grid=this.$('grid');grid.replaceChildren();
      this.$('count').textContent=matches.length?`Rodoma ${visible.length} iš ${matches.length} spalvų`:'Pagal paiešką spalvų nerasta.';
      if (this.$('more')) this.$('more').hidden=visible.length>=matches.length;
      for (const color of visible) {
        const button=document.createElement('button');button.type='button';button.className='im-fabric__swatch';
        button.setAttribute('aria-pressed',String(color===this.pending));button.setAttribute('aria-label',`${color.collection} ${color.code}`);
        const img=document.createElement('img');img.src=color.thumb;img.alt='';img.loading='lazy';img.width=150;img.height=150;
        img.addEventListener('error',()=>{img.hidden=true;button.title='Pavyzdžio nuotrauka nepasiekiama';});
        const label=document.createElement('span');label.textContent=`${color.collection} ${color.code}`;
        button.append(img,label);
        button.addEventListener('click',()=>{this.pending=color;grid.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.preview();});
        grid.append(button);
      }
    }
    preview() {
      const color=this.pending;this.$('confirm').disabled=!color;this.$('hint').hidden=!!color;
      this.$('large').hidden=!color;this.$('zoom').hidden=!color;
      this.$('name').textContent=color?`${color.collection} ${color.code}`:'';
      this.$('details').textContent=color?color.details||'':'';
      this.$('pending').textContent=color?`Pasirinkta: ${color.collection} ${color.code}`:'Spalva dar nepasirinkta';
      if (color) {this.$('large').src=color.image;this.$('large').alt=`${color.collection} ${color.code} – audinio faktūra`;this.$('zoom').href=color.image;}
      else {this.$('large').removeAttribute('src');this.$('zoom').removeAttribute('href');}
    }
  });
}

/* Presentation only: preserve the picker, catalog and form handlers above. */
function imSetupMobileFabricFilters(picker) {
  if (!window.matchMedia || picker.querySelector('.im-fabric__filter-shell')) return;
  const filters = picker.querySelector('.im-fabric__filters');
  const body = picker.querySelector('.im-fabric__body');
  const collection = picker.querySelector('[data-im-collection]');
  const dialog = picker.querySelector('dialog');
  const mobile = window.matchMedia('(max-width: 700px)');
  const shell = document.createElement('div'); shell.className = 'im-fabric__filter-shell';
  const toggle = document.createElement('button'); toggle.type = 'button';
  toggle.className = 'im-fabric__filter-toggle';
  toggle.innerHTML = '<span></span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  filters.id = `${dialog.getAttribute('aria-labelledby')}-filters`;
  toggle.setAttribute('aria-controls', filters.id);
  filters.before(shell); shell.append(toggle, filters);
  let collapsed = false, lastY = 0, down = 0, settling = 0;
  const measure = () => {
    if (mobile.matches && filters.offsetHeight) shell.style.setProperty('--im-filter-height', `${filters.offsetHeight}px`);
  };
  const label = () => {
    const name = collection.options[collection.selectedIndex]?.textContent || 'Audinių kolekcija';
    toggle.querySelector('span').textContent = name;
    toggle.setAttribute('aria-label', `${name} – išskleisti kolekcijos pasirinkimą ir paiešką`);
  };
  const expand = (hide) => {
    collapsed = mobile.matches && hide;
    measure(); label();
    shell.classList.toggle('is-collapsed', collapsed);
    toggle.setAttribute('aria-expanded', String(!collapsed));
    filters.inert = collapsed;
    settling = performance.now() + 260; down = 0; lastY = body.scrollTop;
  };
  toggle.addEventListener('click', () => {
    expand(false);
    collection.focus({preventScroll:true});
  });
  collection.addEventListener('change', label);
  body.addEventListener('pointerdown', () => {
    if (mobile.matches && filters.contains(document.activeElement)) document.activeElement.blur();
  }, {passive:true});
  body.addEventListener('scroll', () => {
    const y = Math.max(0, body.scrollTop), delta = y - lastY; lastY = y;
    if (!mobile.matches || !dialog.open || performance.now() < settling) return;
    // Keep an active search/select visible; never reset the color list position.
    if (filters.contains(document.activeElement)) return;
    down = delta > 0 ? down + delta : 0;
    if (!collapsed && y > 24 && down > 18) expand(true);
  }, {passive:true});
  new MutationObserver(() => { if (dialog.open) expand(false); }).observe(dialog, {attributes:true, attributeFilter:['open']});
  const resize = new ResizeObserver(measure); resize.observe(filters);
  const onBreakpoint = () => {
    if (!picker.isConnected) {mobile.removeEventListener('change', onBreakpoint);resize.disconnect();return;}
    expand(false);
  };
  mobile.addEventListener('change', onBreakpoint);
  expand(false);
}
